module.exports = __webpack_public_path__ + "static/assets/1284ac98b48c05d0b81c1eb23532594a.png";